// Nhóm lọc "Trạng thái ghi sổ" của danh sách chứng từ nguồn ở chế độ Kế toán (đợt 5, TH-00 mục 6.8).
// ledger_status là điều kiện ảo: BE lọc trong beforeGetAll của bảng (accounting/ledgerStatus.js).
const TEXT = {
    All: { vi: 'Tất cả', en: 'All', fr: 'Tout', es: 'Todo', id: 'Semua', ja: 'すべて', zh: '全部', ko: '전체', hi: 'सभी', ar: 'الكل' },
    Pending: { vi: 'Chờ ghi sổ', en: 'Pending Postings', fr: 'Écritures en attente', es: 'Asientos pendientes', id: 'Posting tertunda', ja: '転記待ち', zh: '待过账', ko: '전기 대기', hi: 'लंबित पोस्टिंग', ar: 'الترحيل المعلق' },
    Posted: { vi: 'Đã ghi sổ', en: 'Posted', fr: 'Comptabilisé', es: 'Registrado', id: 'Diposting', ja: '転記済', zh: '已过账', ko: '전기됨', hi: 'पोस्ट किया गया', ar: 'مُرحّل' },
    Error: { vi: 'Lỗi', en: 'Error', fr: 'Erreur', es: 'Error', id: 'Galat', ja: 'エラー', zh: '错误', ko: '오류', hi: 'त्रुटि', ar: 'خطأ' }
};

export const LEDGER_STATUS_TEXT = TEXT;

export const LEDGER_STATUS_GROUPS = [
    { name: 'All', default: true, text: TEXT.All, searchConditions: {} },
    ...['Pending', 'Posted', 'Error'].map((status) => ({ name: 'Ledger' + status, text: TEXT[status], searchConditions: { ledger_status: status } }))
];

const NEW_TEXT = { vi: 'Mới tạo', en: 'New', fr: 'Nouveau', es: 'Nuevo', id: 'Baru', ja: '新規', zh: '新建', ko: '신규', hi: 'नया', ar: 'جديد' };

// Bảng nguồn có trạng thái ghi sổ; các tệp màn đợt 5 thêm tên bảng của mình vào đây. Giá trị: nhóm thêm sau "Tất cả"
// (TIEN-01/02: "Mới tạo" theo trạng thái phiếu).
export const LEDGER_SOURCE_TABLES = {
    EXROtherOrder: [], FAAssetRegister: [], FAAssetAdjInc: [], FAAssetAdjDec: [], FAAssetDispose: [],
    CAReceive: [{ name: 'New', text: NEW_TEXT, searchConditions: { receive_status: 'New' } }],
    CAIssue: [{ name: 'New', text: NEW_TEXT, searchConditions: { issue_status: 'New' } }],
    // MUA-02: danh sách Chi phí mở sẵn nhóm Chờ ghi sổ, không có nhóm Tất cả.
    EXPGeneralOrder: { extra: [{ name: 'New', text: NEW_TEXT, searchConditions: { order_status: 'New' } }], defaultName: 'LedgerPending', withAll: false },
    // TS-04: danh sách khấu hao mở sẵn nhóm Chờ khấu hao (giữ điều kiện của pack có sẵn), không có nhóm Tất cả.
    FAAssetDepreciate: {
        extra: [{ name: 'new', text: { vi: 'Chờ khấu hao', en: 'Waiting', fr: 'En attente', es: 'Esperando', id: 'Menunggu', ja: '待機中', zh: '等待中', ko: '대기 중', hi: 'प्रतीक्षा में', ar: 'في الانتظار' }, searchConditions: { status: 'New', month_id_endCurrentMonth: 1 } }],
        defaultName: 'new',
        withAll: false
    },
    // TS-11: phân bổ CCDC mở sẵn Chờ phân bổ chi phí; ghi giảm CCDC có nhóm Mới tạo.
    FAEquipmentDepreciate: {
        extra: [{ name: 'new', text: { vi: 'Chờ phân bổ chi phí', en: 'Waiting', fr: 'En attente', es: 'Esperando', id: 'Menunggu', ja: '待機中', zh: '等待中', ko: '대기 중', hi: 'प्रतीक्षा में', ar: 'في الانتظار' }, searchConditions: { status: 'New', month_id_endCurrentMonth: 1 } }],
        defaultName: 'new',
        withAll: false
    },
    FAEquipmentDispose: [{ name: 'New', text: NEW_TEXT, searchConditions: { status: 'New' } }],
    CAAdjust: [
        { name: 'New', text: NEW_TEXT, searchConditions: { adjust_status: 'New' } },
        { name: 'CashCount', text: { vi: 'Kiểm kê quỹ', en: 'Cash count', fr: 'Comptage de caisse', es: 'Arqueo de caja', id: 'Opname kas', ja: '現金実査', zh: '现金盘点', ko: '현금 실사', hi: 'नकद गणना', ar: 'جرد النقدية' }, searchConditions: { reason_code: 'CashCount' } }
    ]
};

// Khai của bảng: mảng = nhóm thêm sau "Tất cả"; đối tượng { extra, defaultName, withAll } = đổi nhóm mở sẵn / bỏ "Tất cả".
export function ledgerGroupsOf(table) {
    const spec = LEDGER_SOURCE_TABLES[table] || [];
    const { extra = [], defaultName = 'All', withAll = true } = Array.isArray(spec) ? { extra: spec } : spec;
    const groups = [...(withAll ? [LEDGER_STATUS_GROUPS[0]] : []), ...extra, ...LEDGER_STATUS_GROUPS.slice(1)];
    return groups.map(({ default: _ignored, ...group }) => (group.name === defaultName ? { ...group, default: true } : group));
}

export default Object.keys(LEDGER_SOURCE_TABLES).map((table) => ({ name: table + 'Ledger', value: ledgerGroupsOf(table) }));
